// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';

const DispatchApi = ApiFactory.get('dispatchers');

const fetch = async ( { commit }, id) => {
  const { data } = await DispatchApi.get(id);
  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      commit(`SET_${key.toUpperCase()}`, data[key]);
    }
  }
};

export default {
  fetch
};
